import { Component } from "@angular/core";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";

@Component({
    selector: C.EWIZ_ECIES_SUCI_CALCUATION_SCHEME,
    templateUrl: "./ecies-suci-calculation-schema.component.html",
    standalone: false
})
export class EWizECIESSuciCalcuationSchemeComponent extends EWizDynamicBaseClassComponent {}
